<template>
  <div class="schedule">
    <div class="container">
      <div class="row">
        <div class="close">
          <i @click="$emit('closeSchedulePopup')" class="fa fa-times m-3" />
        </div>
        <div class="bg-lilac inner" v-html="scheduleContent" />
      </div>
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';

export default {
  directives: {
    onClickaway,
  },

  props: {
    scheduleContent: {
      type: String,
      required: false,
    },
  },

};
</script>
